<script lang="ts">
	import { AdaptiveTextInput, Popper } from "@hitit/new_ui/src";
	export let name = "";
	export let value = "";
	export let editmode = false;
	export let description = "";
	export let length = Infinity
	export let clearCallback = () => (value = "");

</script>

<div class="container" class:editmode>
	<div class="name">
		{name}
		{#if description}
			<div class="popper">
				<Popper description={description} fill={'#bcbfc3'} />
			</div>
		{/if}
	</div>
	<div class="value-box">
		{#if editmode}
			{#if $$slots.input}
				<slot name="input" />
			{:else}
				<div class="input">
					<AdaptiveTextInput
						bind:value
						length={length}
						backgroundColor={'#f0f0f4'}
						on:input
						clearCallback={clearCallback} />
				</div>
			{/if}
		{:else if $$slots.value}
			<slot name="value" />
		{:else}
			<p class="value">{value}</p>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;

		.name {
			display: flex;
			align-items: center;
			gap: 10px;
			color: #6d6f76;
		}

		.value {
			font-weight: 500;
			color: #46474b;
			line-height: 22px;
		}

		.popper {
			width: 20px;
			height: 20px;
			font-size: 0.875rem;
			color: #46474b;
		}

		&.editmode {
			gap: 10px;

			.value-box {
				flex-grow: 1dpdpd;
			}

			.input {
				flex-grow: 1;
				height: 31px;
				color: #46474b;
				font-size: 1rem;
			}
		}
	}

	@include DesktopSize {
		.container {
			.name {
				font-size: 1.25rem;
			}
			.value {
				font-size: 1.25rem;
				line-height: 30px;
			}

			.popper {
				font-size: 1rem;
			}

			&.editmode {
				gap: 10px;
				.input {
					height: 40px;
					width: 100%;
					max-width: calc(100% - 40px);
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
